module.exports = __webpack_public_path__ + "img/exam_jan_2025_1xfl3xmt.ec6e191e.jpg";